import isArray from "lodash/isArray";

const updateById = (obj, updatedElement) => {
  const updateElement = (el) => {
    if (el.id !== updatedElement.id) {
      return { ...el };
    }

    return { ...el, ...updatedElement };
  };
  if (isArray(obj)) {
    return obj.map((el) => updateElement(el));
  }

  return updateElement(obj);
};

export default updateById;
